module.exports = __webpack_public_path__ + "images/FUSA_icons/082-fragile.8b838d07235f548591996c7b13a389c2.svg";